﻿define('SageDotCom/Components/CallButton',['jquery', 'SageDotCom/DataLayer/tealium', 'SageDotCom/DataLayer/Events/contactus'], function($, tealium, contactUsEvent) {
    function CallButton(scope, number) {
        tealium.registerPageData({ 'page_phone_number': number });

        const $parentLi = $(scope).parent("li");
        const $parentUl = $parentLi.parent("ul");
        if ($parentUl.length === 0) {
            //need to swap the li to a span
            const $clonedScope = $(scope).clone();
            const $span = $(document.createElement("span"));
            $.each($parentLi.get(0).attributes,
                function() {
                    $span.attr(this.name, this.value);
                });

            $span.append($clonedScope);
            $parentLi.replaceWith($span);

            scope = $clonedScope.get(0);
        }

        $("img, span", scope).on("click", function(event){
            var data = contactUsEvent.GenerateEventMetadata(event.currentTarget, $(".telephone-text", scope).text());
            tealium.event(data);
        });
    }

    return function init(args) {
        return args.IsExperienceEditorEditing ? null : new CallButton(args.scope, args.Phone);
    }
});
